/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./classificationList.vue?vue&type=template&id=ba35d070&scoped=true&"
import script from "./classificationList.vue?vue&type=script&lang=js&"
export * from "./classificationList.vue?vue&type=script&lang=js&"
import style0 from "./classificationList.vue?vue&type=style&index=0&id=ba35d070&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba35d070",
  null
  
)

export default component.exports